var totalAdult = 0;
var totalChild = 0;
var totalRoomCount = 0;
var totalPrice = 0.0;
var currency="";
var selectedBoards = [];

$(document).ready(function() {
	$('select.roomPickSelect:first option:last').prop('selected', true);
	$('select.roomPickSelect').on('change',function(){
		totalAdult = 0;
		totalChild = 0;
		totalRoomCount = 0;
		totalPrice = 0.0;
		currency="";
		var roomNames = '';
		var boardNames = '';
		selectedBoards = [];
		$(".roomNumValue").val(0);
		$('select.roomPickSelect').each(function(idx,room){
			var roomCount = parseInt($(room).val());
			var roomIndex = $(room).attr("index");
			var boardIndex = $(this).attr("boardIndex");
			if (roomCount > 0) {
				totalPrice += parseFloat($(room).attr('price')) * roomCount;
				roomNames += $(room).attr('roomName') + ' x ' + roomCount + '<br> ';
				boardNames += $(room).attr('boardName') + ' ';
				currency = $(room).attr('currency');
				totalAdult += parseInt($(room).attr('adultCount')) * roomCount;
				totalChild += parseInt($(room).attr('childCount')) * roomCount;
				totalRoomCount += roomCount;
				selectedBoards.push(boardIndex);
				$("[name=selectedBoardIndex]").val(selectedBoards.join());
			}
			$("#roomNum_"+ boardIndex+ "_" + roomIndex).val(roomCount);
		});
		$('.totalPrice').html(totalPrice.toFixed(2).replace('.',',').replace(/\d(?=(\d{3})+\,)/g, '$&.') + ' ' + currency);
		$('#perPersonPrice').html((totalPrice / (totalAdult + totalChild)).toFixed(2).replace('.',',').replace(/\d(?=(\d{3})+\,)/g, '$&.') + ' ' + currency);
		$('.roomNames').html(roomNames);
		$('#boardNames').html(boardNames);
            
	}).trigger('change');
	
	$('input.roomPickSelect').on('change',function(){
		totalAdult = 0;
		totalChild = 0;
		totalRoomCount = 0;
		totalPrice = 0.0;
		currency="";
		var roomNames = '';
		var boardNames = '';
		selectedBoards = [];
		$(".roomNumValue").val(0);
		$(".roomSelectValue").val(0);
		var room = $('input.roomPickSelect:checked');
		if (room.length > 0){
			var roomIndex = $(room).attr("index");
			var boardIndex = $(this).attr("boardIndex");
			selectedBoards.push(boardIndex);
			$("[name=selectedBoardIndex]").val(selectedBoards.join());
			$("#roomNum_"+ boardIndex+ "_" + roomIndex).val(1);
			$("#roomSelect_"+ boardIndex+ "_" + roomIndex).val(1);
			totalPrice = parseFloat($(room).attr('price'));
			totalAdult = parseInt($(room).attr('adultCount'));
			totalChild = parseInt($(room).attr('childCount'));
			totalRoomCount = 1;
			currency = $(room).attr('currency');
			roomNames = $(room).attr('roomName') + ' x 1';
			boardNames = $(room).attr('boardName');
		}
		$('.totalPrice').html(totalPrice.toFixed(2).replace('.',',').replace(/\d(?=(\d{3})+\,)/g, '$&.') + ' ' + currency);
		$('#perPersonPrice').html((totalAdult + totalChild > 0 ? totalPrice / (totalAdult + totalChild) : 0).toFixed(2).replace('.',',').replace(/\d(?=(\d{3})+\,)/g, '$&.') + ' ' + currency);
		$('.roomNames').html(roomNames);
		$('#boardNames').html(boardNames);
	});
	$('input.roomPickSelect:first').prop('checked',true).trigger('change');
	
	bindDatePicker();
	bindRoomSelector();
	
	$('#datesDetail').daterangepicker({
	  minDate: moment(),
	  minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  locale: {
	    format: 'DD.MM.YYYY'
	  },
	  startDate: $('input[name="checkInDate"]').val().length > 0 ? moment($('input[name="checkInDate"]').val(),'DD.MM.YYYY') : moment(),
	  endDate: $('input[name="checkOutDate"]').val().length > 0 ? moment($('input[name="checkOutDate"]').val(),'DD.MM.YYYY') : moment()
	});
	
	$('#datesDetail').on('apply.daterangepicker', function(ev, picker) {
		$('input[name="checkInDate"]').val(picker.startDate.format('DD.MM.YYYY'));
		$('input[name="checkOutDate"]').val(picker.endDate.format('DD.MM.YYYY'));
	});
	$( ".show-photos" ).click(function() {
		$("#photosModal").modal('show');
	});
	$( ".btn-rooms" ).click(function() {
		$(".collapseRooms2").toggleClass("d-none");
		$(".collapseRooms1").toggle();
		$(".room-section").toggleClass("mb-5");
	});
	setTimeout(function(){ 
		$('.call-to-action').addClass("show");
	}, 5000); 
	
	var stickyBottomOffset = $('#sticky-end').height() + $('footer').height();
	$(".sticky").sticky({ topSpacing: 20, bottomSpacing: stickyBottomOffset + 50 });
	
	//  Availability Calendar
    var NUMERIC_DATE_FORMATTER = new Intl.DateTimeFormat('tr-TR', {
        day : 'numeric',
        month : 'numeric',
        year : 'numeric'
    });

    if(typeof availabilityCalendarTitle == "undefined"){
        $('#availability-calendar').modal('hide');
    }

    $('.availability-btn').click(function () {
        var roomId = $(this).data('roomid');

        var selectedRoomName = $(this).data('roomname');
        $('#pSelectedRoomName').text(selectedRoomName);

        var selectedAdultCapacity = $(this).data('roomadultcapacity');
        var selectedChildCapacity = $(this).data('roomchildcapacity');
        var roomCapacityText = selectedAdultCapacity ;
        if (selectedChildCapacity > 0)
            roomCapacityText = roomCapacityText.concat(selectedChildCapacity);
		
		if (selectedAdultCapacity > 0)
        $('#pSelectedRoomCapacity').html(roomCapacityText);

        var autoCompleteId = searchAutoCompleteId;
        var checkInDate = new Date(searchFromDate);
        var marketId = $(this).data('marketid');

        var getRoomStatesUrl = "/hotel/roomStates?roomId=" + roomId + "&checkInDate=" + formatDate(checkInDate, '-') + "&autoCompleteId=" + autoCompleteId+ "&marketId=" + marketId;

        var defaultDate = initAvailabilityCalendarDefaultDate(checkInDate);

        $('#availability-calendar').modal('show');


        $.ajax({
            url:getRoomStatesUrl,
            beforeSend: function(){
                $('#availability-calendar-item').datepicker('destroy');
            },
            success: function (response) {
                    $('#availability-calendar-item').datepicker({
                        dateFormat : "dd.mm.yy",
                        yearRange: "0:+1",
                        minDate: 0,
                        numberOfMonths: 3,
                        changeMonth: false,
                        changeYear: false,
                        showButtonPanel: false,
                        showWeek: false,
                        firstDay: 1,
                        defaultDate: defaultDate.trim(),
                        onSelect: configureSearchDates,
                        beforeShowDay: function (date) {
                            return drawBox(date, response);
                        }
                    });
            },
            complete: function () {
                $('#availability-calendar-item').datepicker('refresh');
            }
        });

    });

    function initAvailabilityCalendarDefaultDate(checkInDate) {

        var defaultDate = '';
        var today = new Date();
        var yearDiff = checkInDate.getFullYear() - today.getFullYear();
        var monthDiff = checkInDate.getMonth() - today.getMonth();

        if (yearDiff != 0) {
            if (yearDiff < 0)
                defaultDate = defaultDate.concat('-', yearDiff, 'y');
            else
                defaultDate = defaultDate.concat('+', yearDiff, 'y');
        }

        if (monthDiff != 0) {
            if (monthDiff < 0)
                defaultDate = defaultDate.concat(' -', monthDiff, 'm');
            else
                defaultDate = defaultDate.concat(' +', monthDiff, 'm');
        }

        return defaultDate;
    }

    function drawBox(date, roomStatesData) {
        var _classname;
        var formattedDate= formatDate(date, '-', true);
        var _tooltip = formattedDate;
        var _enabled = false;
        var roomStatesAsJson = jQuery.parseJSON(roomStatesData);

        var checkInDateValue = new Date(selectedDates[0]);
        var checkOutDateValue = new Date(selectedDates[1]);

        $.each(roomStatesAsJson.roomStates, function (i, val) {
            if (formattedDate == val.date) {
                _tooltip += ' | availability:' + val.availability + ' | hasStop:' + val.hasStop + ' | release:' + val.release;
                var _hasStop = val.hasStop.toString() == "true" || val.hasStop.toString() == "True";
                var _available= parseInt(val.availability) > 0;
                
                if (checkInDateValue.getTime() <= date.getTime() && checkOutDateValue.getTime() >= date.getTime()) {
                    _enabled = true;
                    _classname = "highlight-selected-date";
                }
                if (_hasStop || !_available) {
                	_enabled = true;
                    _classname += " highlight-unavailable-date";
                } else {
                	 _enabled = true;
                     _classname += " highlight-available-date";
                } 
            }
        });

        return new Array(_enabled, _classname);
    }

    function formatDate(date, seperator, yearMonthDay) {
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var dateParts=[day, month, year];
        if (yearMonthDay)
            return dateParts.reverse().join(seperator);
        return dateParts.join(seperator);
    }

    
    var availabilityCalendarDateHolder1;
    var availabilityCalendarDateHolder2;

    function configureSearchDates(date) {

        var selectedDate = $.datepicker.parseDate('dd.mm.yy', date).getTime();

        if (availabilityCalendarDateHolder1 == null)
            availabilityCalendarDateHolder1 = selectedDate;
        else if (availabilityCalendarDateHolder2 == null && selectedDate!=availabilityCalendarDateHolder1) {
            if (selectedDate > availabilityCalendarDateHolder1)
                availabilityCalendarDateHolder2 = selectedDate;
            else
                availabilityCalendarDateHolder1 = selectedDate;
        }

        if (availabilityCalendarDateHolder1 != null && availabilityCalendarDateHolder2 != null) {
            selectedDates.splice(0, selectedDates.length);

            selectedDates[0] = availabilityCalendarDateHolder1;
            selectedDates[1] = availabilityCalendarDateHolder2;

            selectedDates.sort(function (a, b) {
                return  a - b;
            });

            var formattedCheckInDate = formatDate(new Date(selectedDates[0]), '.', false);
            var formattedCheckOutDate = formatDate(new Date(selectedDates[1]), '.', false);

            $("[name=checkInDate]", document).val(formattedCheckInDate);
            $("[name=checkOutDate]", document).val(formattedCheckOutDate);

            $('#selectedCheckInDate').html(formattedCheckInDate);
            $('#selectedCheckOutDate').html(formattedCheckOutDate);

            availabilityCalendarDateHolder1 = null;
            availabilityCalendarDateHolder2 = null;

            putCookieSearchValues();

            $('#availability-calendar').modal('hide');
        }
    }

    //~~~Availability Calendar~~~

	$(document).on("click",".room-photo-link",function() {
		var index = $( this ).data("roomindex");
		$(document).find('#room-photo-gallery_'+index+'').modal('show');
		
		if ($('#roomPhotos_'+index+'').length > 0) {
			var slider = tns({
			  container: '#roomPhotos_'+index+'',
			  items: 1,
			  controlsText: ["←", "→"],
			  controlsPosition: "bottom",
			  nav: false,
			  loop: false,
			  swipeAngle: false,
			  lazyload: true,
			  mouseDrag: true,
			  speed: 400,
			  responsive: {
			    900: {
			      items: 2
			    }
			  }
			});
		}
	});
	
});

function bookHotel() {
  	var numAdult = parseInt($("#adultCount").val());
  	var numChild = parseInt($("#childCount").val());
  	var numRoom = parseInt($("#numRoom").val());
  
  	if (totalAdult < numAdult){
		alert(FmtMessage.getMessage('js.adult.count.less'));
		return;
  	} 
  
  	if (totalChild < numChild){
	  	alert(FmtMessage.getMessage('js.child.count.less'));
	  	return;
  	}

  	if(totalRoomCount > numRoom){
      	alert(FmtMessage.getMessage('js.room.count.invalid'));
      	return;
  	}
  
	$('#loading').modal('show');
  	$("#priceDetailHotelForm").submit();
}

function initMap() {
	var map = new google.maps.Map(document.getElementById("map"), {
		zoom: 12,
		center: hotelMap,
		styles: [
			{
				elementType: "geometry",
			    stylers: [{ color: "#FFFFFF" }],
			},
			{
		      	elementType: "labels.icon",
		      	stylers: [{ visibility: "off" }],
		    },
		    {
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#616161" }],
		    },
		    {
		      	elementType: "labels.text.stroke",
		      	stylers: [{ color: "#ffffff" }],
		    },
		    {
		      	featureType: "administrative.land_parcel",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#bdbdbd" }],
		    },
		    {
		      	featureType: "poi",
		      	elementType: "geometry",
		      	stylers: [{ color: "#eeeeee" }],
		    },
		    {
		      	featureType: "poi",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#757575" }],
		    },
		    {
		      	featureType: "poi.park",
		      	elementType: "geometry",
		      	stylers: [{ color: "#bff1d3" }],
		    },
		    {
		      	featureType: "poi.park",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#9e9e9e" }],
		    },
		    {
		      	featureType: "road",
		      	elementType: "geometry",
		      	stylers: [{ color: "#F36326" }],
		    },
		    {
		      	featureType: "road.arterial",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#757575" }],
		    },
		    {
		      	featureType: "road.highway",
		      	elementType: "geometry",
		      	stylers: [{ color: "#F36326" }],
		    },
		    {
		      	featureType: "road.highway",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#616161" }],
		    },
		    {
		      	featureType: "road.local",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#9e9e9e" }],
		    },
		    {
		      	featureType: "transit.line",
		      	elementType: "geometry",
		      	stylers: [{ color: "#F36326" }],
		    },
		    {
		      	featureType: "transit.station",
		      	elementType: "geometry",
		      	stylers: [{ color: "#eeeeee" }],
		    },
		    {
		      	featureType: "water",
		      	elementType: "geometry",
		      	stylers: [{ color: "#e8f9ff" }],
		    },
		    {
		      	featureType: "water",
		      	elementType: "labels.text.fill",
		      	stylers: [{ color: "#9e9e9e" }],
		    }
	    ]
	});
		  
	var mappin = "/images/entatil/icons/svg/pin-o.svg";
  
	var marker = new google.maps.Marker({
		position: hotelMap,
		map: map,
		icon: mappin,
	});
}

function bindRoomSelector(context) {
	if (context == undefined)
		context = document;
	
	$(".roomSelect", context).on('change', function(event) {
		var roomCount = $(this).val();
		$(".roomSelect").val(roomCount);
		$(".travelerSelectRoom").html(roomCount);
		
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
				$(".room" + i).addClass('d-flex').show();
			} else {
				$(".room" + i).hide().removeClass('d-flex');
			}
		}
		
		setTotalGuest($(this).closest("form"));
		
		var locale = $.cookie('siteLocale');
		if(locale == "en" && roomCount > 1){
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.rooms'));
		}else{
			$(".travelerRoomFmt").html(FmtMessage.getMessage('js.hotel.search.title.room'));
		}
	}).change();

	$(".childCount", context).on('change', function (event) {
		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".travelerSelectGuest").html(totalGuest);
	var locale = $.cookie('siteLocale');
	if(locale == "en" && totalGuest > 1){
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guests'));
	}else{
		$(".travelerGuestFmt").html(FmtMessage.getMessage('js.hotel.search.title.guest'));
	}
}

function openShareWindows(url, target){
	switch(target) {
    case 'facebook':
    	window.open('https://www.facebook.com/sharer/sharer.php?u='+url+'','popup','width=600,height=600,scrollbars=no,resizable=no');
        break;
    case 'twitter':
    	window.open('https://twitter.com/home?status='+url+'','popup','width=600,height=600,scrollbars=no,resizable=no');
        break;
    case 'googlePlus':
    	window.open('https://plus.google.com/share?url='+url+'','popup','width=600,height=600,scrollbars=no,resizable=no');
        break;
    default:
       break;
	}
}